<template>
  <div>
    <textarea :name="propName" v-model="inputValue" rows="6" :placeholder="propOptions.example" class="u-input-textarea" ref="input" @input="handleInput"></textarea>
    <p class="c-red" v-for="error in errors">{{ error }}</p>
  </div>
</template>

<script>
export default {
  props: {
    propName: String,
    propValue: [String, Number],
    propOptions: {
      type: Object,
      default: () => ({}),
    },
    propOptional: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: this.propValue || '',
      debounceTimer: null,
      lastEmitted: null,
      errors: [],
    }
  },
  beforeDestroy() {
    clearTimeout(this.debounceTimer);
  },
  methods: {
    getErrors() {
      const errors = [];
      if (!this.propOptional && this.inputValue.trim() === '') {
        errors.push('入力してください');
      }
      return errors;
    },
    handleInput() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.errors = this.getErrors();
        const event = this.errors.length === 0 ? 'valid' : 'invalid';
        if (event !== this.lastEmitted) {
          this.lastEmitted = event;
          this.$emit(event);
        }
      }, 300);
    },
    validate() {
      const event = this.getErrors().length === 0 ? 'valid' : 'invalid';
      this.lastEmitted = event;
      this.$emit(event);
    }
  }
}
</script>
